// CANONICAL COPY (GH #7115). src/constants/obligations/obl-bc-exercise.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-bc-exercise',
  title: 'Exercise and test business continuity arrangements',
  description:
    'Confirm that business continuity plans, procedures and solutions are exercised and tested at planned intervals and after significant change (ISO 22301 Cl. 8.5). Exercises shall use scenarios consistent with the continuity objectives, validate that recovery objectives can be met, and produce documented results that are reviewed and used to correct and improve continuity arrangements. Review the exercise programme, the most recent exercise reports and evidence that findings are tracked to closure.',
  category: 'continuity',
  // SCF-BCM-005 is the dedicated "exercising and testing" control, but ISO
  // 22301 is the ONLY framework that maps it. Every other framework folds
  // continuity testing into SCF-BCM-002 ("ICT readiness shall be planned,
  // implemented, maintained AND TESTED") — ISO 27002 A.5.30, CIS-11.5 "Test
  // Data Recovery", NIS2 Art. 21(2)(c), DORA Art. 7, NIST CSF RC.RP-*.
  //
  // ObligationCatalog.jsx lists an obligation only when one of its derived
  // frameworkIds is a framework the tenant has enabled, so with SCF-BCM-005
  // alone this obligation was invisible to every tenant not running ISO 22301
  // — it could never be enabled, never materialise a task, and therefore never
  // be advanced by the completed DR test its continuity-exercise-evidence
  // criterion checks for (#5005). obl-bcp-plan also cites SCF-BCM-002, but it
  // only checks that a plan DOCUMENT is published; nothing was checking that
  // the plan had actually been exercised.
  scfIds: ['SCF-BCM-005', 'SCF-BCM-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'continuity-exercise-evidence',
      description:
        'A published, current exercise report exists, or a DR test/exercise was passed within the last year',
    },
    // SCF-BCM-002 covers ICT readiness being MAINTAINED, not only tested. An
    // exercise a year ago says nothing about whether the procedures it
    // exercised still describe the systems — so the arrangements are not
    // "maintained" while an active runbook's review is overdue, or while a
    // runbook has been edited since the last person reviewed it.
    {
      type: 'runbook-review-current',
      description:
        'Every active ICT recovery runbook carries a review that is neither overdue nor outdated by a later edit',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
